import type { ServerNotificationsEvent } from '@/types/ServerEvent';
import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class ServerSideCurrentNotificationsEvent extends EventV2<ServerNotificationsEvent> {}
